"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGMove = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var svg_event_translation_1 = require("./svg.event.translation");
var SVGMove = /** @class */ (function () {
    function SVGMove(dc, ctx, svg) {
        this.dc = dc;
        this.ctx = ctx;
        this.svg = svg;
    }
    SVGMove.prototype.start = function () {
        var dc = this.dc;
        this.startPoint = { x: 0, y: 0 };
        this.lastPoint = { x: 0, y: 0 };
        this.delta = { x: 0, y: 0 };
        this.pt = this.svg.createSVGPoint();
        this.ctm = this.svg.getScreenCTM();
        this.moving = true;
        this.pt.x = this.ctx.$event.clientX;
        this.pt.y = this.ctx.$event.clientY;
        var current = svg_event_translation_1.SVGEventTranslation.translatePoint(this.pt, this.ctm);
        this.lastPoint.x = this.startPoint.x = current.x;
        this.lastPoint.y = this.startPoint.y = current.y;
        this.boundEnd = this.end.bind(this);
        var $window = dc.window;
        $window.addEventListener('mouseup', this.boundEnd);
        $window.addEventListener('touchend', this.boundEnd);
        this.boundMove = this.move.bind(this);
        this.svg.addEventListener('mousemove', this.boundMove);
        this.svg.addEventListener('touchmove', this.boundMove);
        if (this.onStart) {
            this.onStart();
        }
        this.boundMoveTick = this.moveTick.bind(this);
        $window.requestAnimationFrame(this.boundMoveTick);
    };
    SVGMove.create = function (dc, ctx) {
        if (ctx.$event.which !== 1) {
            return undefined;
        }
        var svg = svg_event_translation_1.SVGEventTranslation.getSVG(ctx.$event.target);
        if (svg == null) {
            return undefined;
        }
        return new SVGMove(dc, ctx, svg);
    };
    SVGMove.prototype.moveTick = function () {
        var dc = this.dc;
        var $window = dc.window;
        var current = svg_event_translation_1.SVGEventTranslation.translatePoint(this.pt, this.ctm);
        this.delta.x = current.x - this.lastPoint.x;
        this.delta.y = current.y - this.lastPoint.y;
        this.lastPoint.x = current.x;
        this.lastPoint.y = current.y;
        if (this.delta.x !== 0 || this.delta.y !== 0) {
            if (this.onMove) {
                this.onMove();
            }
        }
        if (!this.moving) {
            return;
        }
        $window.requestAnimationFrame(this.boundMoveTick);
    };
    SVGMove.prototype.end = function (event) {
        var dc = this.dc;
        var $window = dc.window;
        this.svg.removeEventListener('mousemove', this.boundMove);
        this.svg.removeEventListener('touchmove', this.boundMove);
        $window.removeEventListener('mouseup', this.boundEnd);
        $window.removeEventListener('touchend', this.boundEnd);
        this.pt.x = event.clientX;
        this.pt.y = event.clientY;
        var current = svg_event_translation_1.SVGEventTranslation.translatePoint(this.pt, this.ctm);
        this.lastPoint.x = current.x;
        this.lastPoint.y = current.y;
        this.moving = false;
        dc.state.moveId = null;
        if (this.onEnd) {
            this.onEnd();
        }
    };
    SVGMove.prototype.move = function (event) {
        this.pt.x = event.clientX;
        this.pt.y = event.clientY;
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGMove.prototype, "end", null);
    return SVGMove;
}());
exports.SVGMove = SVGMove;
//# sourceMappingURL=svg.move.js.map